export interface CCAMSearchEmptyStateProps {
  query: string;
}

/**
 * État vide pour la recherche CCAM
 * Story 2.4: AC4 - Message "Aucun résultat"
 */
export const CCAMSearchEmptyState = ({ query }: CCAMSearchEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center py-12 text-center">
    <div className="text-gray-400 text-5xl mb-4">🔍</div>
    <h3 className="text-lg font-semibold text-gray-700 mb-2">
      Aucun résultat pour "{query}"
    </h3>
    <p className="text-gray-500 max-w-md">
      Essayez d'autres termes ou filtres pour affiner votre recherche.
    </p>
  </div>
);
